import React, { useState } from 'react';
import { PlaneIcon, SunIcon } from 'lucide-react';
import { timeOffEntries } from '../../data/timeOff';
import type { BadgeTone } from '../ui/Badge';
import type { EntryTone, Navigate } from '../../types/hr';
import { displayName, getEmployee } from '../../utils/employees';
import { TODAY, formatRange } from '../../utils/format';
import { isOutOn, overlaps } from '../../utils/timeOff';
import { Avatar } from '../ui/Avatar';
import { Badge } from '../ui/Badge';
import { Card } from '../ui/Card';
import { EmptyState } from '../ui/EmptyState';
const WEEK_START = new Date(2026, 10, 2);
const WEEK_END = new Date(2026, 10, 8);
export const ENTRY_BADGE: Record<EntryTone, BadgeTone> = {
  blue: 'blue',
  teal: 'teal',
  navy: 'navy',
  orange: 'orange'
};
export function WhosOutCard({
  onNavigate
}: {
  onNavigate: Navigate;
}) {
  const [range, setRange] = useState<'today' | 'week'>('today');
  const entries = timeOffEntries.filter(e => range === 'today' ? isOutOn(e, TODAY) : overlaps(e, WEEK_START, WEEK_END));
  return <Card title="Who's out" subtitle={range === 'today' ? 'Wednesday, Nov 4' : 'Week of Nov 2 – 8'} icon={PlaneIcon} action={<div className="flex rounded-lg bg-canvas p-0.5 ring-1 ring-inset ring-slate-200" role="tablist" aria-label="Range" data-id="element-106" data-mp="2em3f3jwdx1ka">
          {(['today', 'week'] as const).map(r => <button key={r} type="button" role="tab" aria-selected={range === r} onClick={() => setRange(r)} className={`rounded-md px-2.5 py-1 text-xs font-medium transition ${range === r ? 'bg-white text-navy shadow-sm' : 'text-muted hover:text-navy'}`} data-id="element-107" data-mp="1mvfa1wrlbc1c">
              {r === 'today' ? 'Today' : 'This week'}
            </button>)}
        </div>} bodyClassName="px-3 pb-3" data-id="element-105" data-mp="25lncecngtygh">
      {entries.length === 0 ? <div className="px-3 pb-3" data-id="element-108" data-mp="185hj592a088g">
          <EmptyState icon={SunIcon} title="Everyone's in" compact data-id="element-109" data-mp="184pwinqnpkub" />
        </div> : <ul className="space-y-0.5" data-id="element-110" data-mp="2bflzd4iht91w">
          {entries.map(entry => {
        const emp = getEmployee(entry.employeeId);
        if (!emp) return null;
        return <li key={entry.id} data-id="element-111" data-mp="2k98s0lrelw6v">
                <button type="button" onClick={() => onNavigate({
            page: 'profile',
            employeeId: emp.id,
            tab: 'timeoff'
          })} className="flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left transition hover:bg-canvas/70" data-id="element-112" data-mp="2g85azvxmdu42">
                  <Avatar name={displayName(emp)} seed={emp.id} size="sm" data-id="element-113" data-mp="21j94w4f4ir63" />
                  <span className="min-w-0 flex-1" data-id="element-114" data-mp="21kk6bxl3jmu1">
                    <span className="block truncate text-sm font-medium text-navy" data-id="element-115" data-mp="1wjwitlw2to4k">{displayName(emp)}</span>
                    <span className="block truncate text-xs text-muted" data-id="element-116" data-mp="3cxecr8igjl6p">{formatRange(entry.start, entry.end)}</span>
                  </span>
                  <Badge tone={ENTRY_BADGE[entry.tone]} data-id="element-117" data-mp="381fij4ag78yd">{entry.policyLabel}</Badge>
                </button>
              </li>;
      })}
        </ul>}
    </Card>;
}